import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Createproject } from 'src/app/model/createproject.model';
import { UserService } from '../../../services/user/user.service';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-addpurchaseorder',
  templateUrl: './addpurchaseorder.component.html',
  styleUrls: ['./addpurchaseorder.component.css']
})
export class AddpurchaseorderComponent implements OnInit {
  roleId: string;
  project: Createproject;
  dropdownSettings = {};
  dropdownSettings2 = {};
  countryData: any;
  languageData: any;
  projectName: string;
  clientName: string;
  desc: string;
  data: any;
  dataL: any;
  dataForId: Vendordata;
  evaluationDataAny: any;
  generateLinkBool: boolean = true;
  compeleteURL: string;
  terminateURL: string;
  quotafullURL: string;
  quotarejectURL: string;
  generateLinkBoolNew: boolean = false;
  generateLinkBoolNew2: boolean = false;
  textBoxBool: boolean = false;
  generateRedirects: boolean = false;
  isDataLoading: boolean = false;
  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private evaluationService: EvaluationService) {
    this.roleId = this.route.snapshot.params.projectid;
    this.projectName = this.route.snapshot.params.projectname;
    this.clientName = this.route.snapshot.params.clientname;
    this.desc = this.route.snapshot.params.desc;

  }

  ngOnInit() {
    //alert(this.roleId)
    debugger;
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'countryID',
      textField: 'countryName',
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.dropdownSettings2 = {
      singleSelection: true,
      idField: 'languageID',
      textField: 'language',
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.project = new Createproject();
    this.resetForm();
    if (this.roleId == undefined || this.roleId == "") {
      this.textBoxBool = true;
      this.generateLinkBool = true;
      this.evaluationService.getAllVendorsForEvaluationForProjectId().subscribe(
        (data) => {
          this.evaluationDataAny = data;
          //this.evaluationData = this.evaluationDataAny;
          this.dataForId = this.evaluationDataAny;
          if (this.dataForId != null && this.evaluationDataAny != null) {
            if (this.evaluationDataAny.length > 0) {
              var id = this.evaluationDataAny.length;
              this.project.projectid = "P100000" + id;
            }
            else {
              this.project.projectid = "P1000000";
            }
          }
          else {
            this.project.projectid = "P1000000";
          }
          //console.log("hello",this.dataForId);
          this.roleId = this.project.projectid
          this.generateRedirects = false;
        }


      )
    }

    else {
      debugger;
      this.textBoxBool = false;
      this.generateLinkBool = false;
      this.generateLinkBoolNew = false;
      this.generateLinkBoolNew2 = true;
      this.generateRedirects = false;
      this.project.projectid = this.roleId;
      this.project.projectname = this.projectName;
      this.project.clientname = this.clientName;
      this.project.projectdescription = this.desc;
    }

    this.getCountryList();
    //this.getLanguageList();
  }

  getCountryList() {
    this.userService.getCountryList().subscribe(
      (data) => {
        debugger;
        this.countryData = data;
        this.data = this.countryData;
        console.log("country list" + this.data[0]);
      }
    )
  }
  onCountrySelect(item: any) {
    console.log(item);
    if (item != null) {
      this.getLanguageListForSurvey(item.countryID);
    }
  }

  onCountryDropDownClose(country: any) {
    console.log("on cancel");
    console.log(country);
    if (!country) {
      this.dataL = [];
      this.project.language = null;
    }
    else {
      if (country.length == 0) {
        this.dataL = [];
        this.project.language = null;
      }
    }


  }

  getLanguageList() {
    debugger;
    this.userService.getLanguageList().subscribe(
      (data) => {
        this.languageData = data;
        this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }

  getLanguageListForSurvey(countryID) {
    if (countryID != null && this.roleId != "") {
      this.userService.getLanguageListForSurvey(this.roleId, countryID).subscribe(
        (data: any) => {
          this.dataL = data;
        }
      )
    }
  }

  OnSubmit(form: NgForm) {
    this.isDataLoading = true;
    console.log(form.value);
    console.log(window.location.href)

    this.projectName = form.value.projectname;
    this.clientName = form.value.clientName;
    this.desc = this.route.snapshot.params.desc;

    this.compeleteURL = window.location.href;
    this.terminateURL = window.location.href;
    this.quotafullURL = window.location.href;
    this.quotarejectURL = window.location.href;

    // this.compeleteURL = this.compeleteURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/1/[RE]");
    // this.terminateURL = this.terminateURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/3/[RE]");
    // this.quotafullURL = this.quotafullURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/2/[RE]");
    // this.quotarejectURL = this.quotarejectURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/4/[RE]");
    this.compeleteURL = this.compeleteURL.replace("createproject", "StartSurvey/" + "1/[RE]");
    this.terminateURL = this.terminateURL.replace("createproject", "StartSurvey/" + "3/[RE]");
    this.quotafullURL = this.quotafullURL.replace("createproject", "StartSurvey/" + "2/[RE]");
    this.quotarejectURL = this.quotarejectURL.replace("createproject", "StartSurvey/" + "4/[RE]");


    form.value.projectid = this.roleId;
    form.value.complete = this.compeleteURL;
    form.value.terminate = this.terminateURL;
    form.value.qf = this.quotafullURL;
    form.value.qcreject = this.quotarejectURL;
    form.value.country = this.project.country[0]['countryID'];
    form.value.language = this.project.language[0]['languageID'];

    this.userService.addProjectDetails(form.value)
      .subscribe((data: any) => {
        this.isDataLoading = false;
        if (data != null && data != undefined) {
          this.generateRedirects = true;
          this.generateLinkBool = false;
          this.generateLinkBoolNew = true;
          this.generateLinkBoolNew2 = false;
        }
        else
        {
          alert("An error occured while creating project. Project with same ID already exist.")
        }
      });
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.project = new Createproject;
  }

  OptionSelected(event) {
    debugger;
    console.log("event", event.target.value);
  }

  clickSurveyLinkFormat(project) {
    debugger;
    console.log("NewProject", project);
    this.project.country = project.country[0]['countryID'];
    this.project.language = project.language[0]['languageID'];
    this.userService.addProjectSecurityDetails(project)
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          this.router.navigate(['/assignsurverlink/' + this.roleId + "/" + this.project.country + "/" + this.project.language + "/" + this.project.quotatarget + "/" + this.project.optimisticcount])
        }
      });
    //this.router.navigate(['/assignsurverlink/'+this.roleId+"/"+this.project.country+"/"+this.project.language+"/"+this.project.quotatarget+"/"+this.project.optimisticcount])
  }


}
